import React from 'react';
import { icons } from '../utilits/icons';




function Navbar(props) {
    return (
        <nav>
          <form action="">
            <input type="text"  placeholder='Search or type'/>
            <button>{icons.search}</button>
          </form>

            <div className="rightBlock">
                <button>{icons.notification}</button>
                <span className='avatar'>avatar</span>
            </div>
        </nav>
    );
}

export default Navbar;